import React, { useEffect, useState } from "react";
import "./AddBillingInfoModal.scss";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalButtons,
  ModalText,
  ModalTitle,
} from "src/app/components/Modal/Modal";
import { Button } from "src/app/components/Button/Button";
import computingTaxesImage from "src/images/computing-taxes.png";
import { useDispatch, useSelector } from "react-redux";
import { getSubscriptionBillingInfo } from "src/redux";
import { RootState } from "src/redux/reducers";
import MemoizedLoader from "src/app/components/Loader/Loader";
import { useHistory } from "react-router-dom";

interface Props {
  onClose: () => void;
}

function AddBillingInfoModal(props: Props) {
  const { onClose } = props;

  const [tabFocused, setTabFocused] = useState(true);

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const { billingInfo, subscriptionPlan } = useSelector(
    (state: RootState) => state.subscriptionReducer,
  );

  const dispatch = useDispatch();
  const history = useHistory();

  const checkTabFocused = () => {
    if (document.visibilityState === "visible") {
      setTabFocused(true);
    } else {
      setTabFocused(false);
    }
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", checkTabFocused);

    return () => {
      document.removeEventListener("visibilitychange", checkTabFocused);
    };
  }, []);

  useEffect(() => {
    if (!activeWorkspaceUuid) return;

    if (tabFocused) {
      dispatch(getSubscriptionBillingInfo(activeWorkspaceUuid));
    }
  }, [activeWorkspaceUuid, tabFocused]);

  // useEffect(() => {
  //   if (subscriptionPlan?.pricingType === PricingType.Custom) {
  //     dispatch(setSubscriptionContactModalDisplayMode("default"));
  //     onClose();
  //   } else if (billingInfo?.billingInfoExists) {
  //     if (!subscriptionPlan?.id) return;
  //     openCheckoutScreen(history, activeWorkspaceUuid, subscriptionPlan.id);
  //   }
  // }, [billingInfo?.billingInfoExists, subscriptionPlan]);

  return (
    <Modal className="add-billing-info-modal" onClose={onClose} buttonsHidden>
      {!billingInfo || billingInfo?.billingInfoExists ? (
        <MemoizedLoader />
      ) : (
        <>
          <div className="add-billing-info-modal__content">
            <ModalTitle>
              <IDHFormattedMessage
                id="ws_add_billing_info_to_complete_payment"
                defaultMessage="Add billing info to complete payment"
              />
            </ModalTitle>

            <ModalText>
              <IDHFormattedMessage
                id="ws_we_need_your_billing_details_to_generate_a_compliant_invoice_and_finalize_your_subscription"
                defaultMessage="We need your billing details to generate a compliant invoice and finalize your subscription."
              />
            </ModalText>

            <ModalButtons>
              <Button
                variant="white-with-border"
                size="large"
                onClick={() => onClose()}
              >
                <IDHFormattedMessage id="ws_close" defaultMessage="Close" />
              </Button>

              <a
                href={billingInfo.billingPortalLink || "#"}
                target={billingInfo.billingPortalLink ? "_blank" : "_self"}
                rel="noreferrer"
              >
                <Button variant="blue" size="large">
                  <IDHFormattedMessage
                    id="ws_continue"
                    defaultMessage="Continue"
                  />
                </Button>
              </a>
            </ModalButtons>
          </div>

          <img src={computingTaxesImage} alt="computing taxes" />
        </>
      )}
    </Modal>
  );
}

export default AddBillingInfoModal;
